<!-- SPDX-License-Identifier: AGPL-3.0-only -->

<script setup lang="ts">
export type UserActionIconName =
  | "password-reset"
  | "status"
  | "rename"
  | "refresh"
  | "details"
  | "firmware-update"
  | "publish"
  | "revoke"
  | "delete";

interface UserActionIconProperties {
  readonly name: UserActionIconName;
}

defineProps<UserActionIconProperties>();
</script>

<template>
  <svg class="user-action-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <template v-if="name === 'password-reset'">
      <circle cx="8" cy="12" r="3.25" />
      <path d="M11.25 12H21m-3 0v3m-3-3v2" />
      <path d="M5.5 7.5A7 7 0 0 1 17 6l1-2m-1 2-2-.5" />
    </template>
    <template v-else-if="name === 'status'">
      <path d="M12 3v9" />
      <path d="M7.1 6.5a8 8 0 1 0 9.8 0" />
    </template>
    <template v-else-if="name === 'rename'">
      <path d="M4 20h4l10.5-10.5a2.12 2.12 0 0 0-3-3L5 17v3Z" />
      <path d="m14.5 7.5 3 3" />
    </template>
    <template v-else-if="name === 'refresh'">
      <path d="M20 12a8 8 0 0 1-13.66 5.66" />
      <path d="M4 12A8 8 0 0 1 17.66 6.34" />
      <path d="M17 2v5h5" />
      <path d="M7 22v-5H2" />
    </template>
    <template v-else-if="name === 'details'">
      <path d="M4 6h16" />
      <path d="M4 12h16" />
      <path d="M4 18h16" />
      <circle cx="7" cy="6" r="1" />
      <circle cx="7" cy="12" r="1" />
      <circle cx="7" cy="18" r="1" />
    </template>
    <template v-else-if="name === 'firmware-update'">
      <path d="M12 4v10" />
      <path d="m8 10 4 4 4-4" />
      <path d="M5 18h14" />
      <path d="M7 21h10" />
    </template>
    <template v-else-if="name === 'publish'">
      <path d="M12 20V7" />
      <path d="m8 11 4-4 4 4" />
      <path d="M5 4h14" />
    </template>
    <template v-else-if="name === 'revoke'">
      <circle cx="12" cy="12" r="8" />
      <path d="m8.5 8.5 7 7" />
    </template>
    <template v-else>
      <path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5" />
    </template>
  </svg>
</template>
